// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { getDomainListFailed, getDomainListRequested, getDomainListSucceeded } from './select-domain.actions';
import { SelectDomainService } from '@par/app/shared/select-domain/services/select-domain.service';
import { Store } from '@ngrx/store';
import { selectDomainListResponse } from './select-domain.selectors';

@Injectable()
export class SelectDomainEffects {

  listRequested$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getDomainListRequested),
      withLatestFrom(this.store.select(selectDomainListResponse)),
      filter(([, response]) => response == null),
      switchMap(() => this.service.getDomainList()
        .pipe(
          map((response) => getDomainListSucceeded({response})),
          catchError(() => of(getDomainListFailed())),
        )),
    ),
  );

  constructor(
    private actions$: Actions,
    private service: SelectDomainService,
    private store: Store,
  ) {
  }
}
